const _defaultExt = "binary";

const mimeType = new Map();
mimeType.set(_defaultExt, "application/octet-stream");
mimeType.set("json", "application/json");

mimeType.set("json", "application/json");
mimeType.set("js", "application/javascript");
mimeType.set("ogg", "application/ogg");
mimeType.set("pdf", "application/pdf");
mimeType.set("zip", "application/zip");
mimeType.set("xml", "application/xml");
mimeType.set("gif", "image/gif");
mimeType.set("jpeg", "image/jpeg");
mimeType.set("jpg", "image/jpeg");
mimeType.set("png", "image/png");
mimeType.set("tiff", "image/tiff");
mimeType.set("css", "text/css");
mimeType.set("csv", "text/csv");
mimeType.set("html", "text/html");
mimeType.set("txt", "text/plain");

const getMimeType = ext => {
  let extLower = ext.toLowerCase().split(".").pop();
  return mimeType.has(extLower)
    ? mimeType.get(extLower)
    : mimeType.get(_defaultExt);
};

export { mimeType as mimeTypeMap, getMimeType };
